module.exports = __webpack_public_path__ + "static/media/ico-pinterest-hover.15b2a4fa.svg";